import { usePathname } from "next/navigation";
import { useEffect } from "react";
import useMounted from "@/lib/helpers/hooks/useMounted.ts";

const FacebookTracker = () => {
  const id = "933179936778448";
  const path = usePathname();

  const mounted = useMounted();

  useEffect(() => {
    if (mounted) {
      import("react-facebook-pixel")
        .then((x) => x.default)
        .then((ReactPixel) => {
          ReactPixel.init(id);
          ReactPixel.pageView();
        });
    }
  }, [path]);

  return <></>;
};

export default FacebookTracker;
